import { filter, find, get } from "lodash";
import { RELATIONSHIP } from "utils/constants";

export const getRelatedPersonUser = (person) => {
  const firstname =
    get(person, "identity.user.firstname") ||
    get(person, "user.firstname") ||
    "";
  const lastname =
    get(person, "identity.user.lastname") || get(person, "user.lastname") || "";

  return { firstname, lastname };
};

export const getRelatedPersonDisplayName = (person) => {
  if (!person) {
    return "";
  }

  const { firstname, lastname } = getRelatedPersonUser(person);
  return `${firstname} ${lastname}`.trim();
};

export const hasRelatedPersonFullName = (person) => {
  const { firstname, lastname } = getRelatedPersonUser(person);
  return Boolean(firstname?.trim() && lastname?.trim());
};

export const buildAcorisBeneficiaries = ({
  relatedPersons = [],
  translate = {},
}) => {
  const spouse = find(relatedPersons, {
    relationship: RELATIONSHIP.SPOUSE,
  });
  const children = filter(relatedPersons, {
    relationship: RELATIONSHIP.CHILD,
  });

  const beneficiaries = [];

  if (spouse && hasRelatedPersonFullName(spouse)) {
    beneficiaries.push({
      name: getRelatedPersonDisplayName(spouse),
      label: get(translate, "SPOUSE", ""),
    });
  }

  children.forEach((child, index) => {
    if (!hasRelatedPersonFullName(child)) {
      return;
    }

    const ordinal = get(
      translate,
      `CHILD_ORDINALS.${index + 1}`,
      `${index + 1}`,
    );
    beneficiaries.push({
      name: getRelatedPersonDisplayName(child),
      label: get(translate, "CHILD", "").replace("{ordinal}", ordinal),
    });
  });

  return beneficiaries;
};

export const shouldShowAcorisBeneficiariesSection = ({ beneficiaries = [] }) =>
  beneficiaries.length > 0;
